import { render, staticRenderFns } from "./PasswordModification.vue?vue&type=template&id=33811578&scoped=true&"
import script from "./PasswordModification.vue?vue&type=script&lang=js&"
export * from "./PasswordModification.vue?vue&type=script&lang=js&"
import style0 from "./PasswordModification.vue?vue&type=style&index=0&id=33811578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33811578",
  null
  
)

export default component.exports